namespace app.toolbar {
    "use strict";
    import IDialogService = angular.material.IDialogService;
    import ITranslateService = angular.translate.ITranslateService;
    import AuthService = app.autenticacao.AuthService;
    import MessagesService = app.support.messaging.MessagesService;
    export class AlterarContaController {

        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
            private $translate: ITranslateService,
            private $window: ng.IWindowService,
            private $state: ng.ui.IStateService,
            private messagesService: MessagesService,
            private gestaoContaService: GestaoContaService,
            private authService: AuthService,
            public setorId: string
        ) { }

        public cancel(): void {
            this.$mdDialog.cancel();
        }

        public confirm(): void {
            this.gestaoContaService.alterarContaAtual(this.setorId)
                .then(result => {
                    this.authService.clearCache();
                    this.$mdDialog.hide();
                    this.messagesService.success(this.$translate.instant("TOOLBAR.ALTERAR_CONTA.CONTA_ALTERADA_SUCESSO"));
                    this.$window.location.href = "/tarefas";
                });
        }
    }

    angular
        .module("app.toolbar")
        .controller("app.toolbar.AlterarContaController", AlterarContaController);
}